import React from 'react';
import { FaExclamationTriangle, FaSignInAlt, FaTimesCircle } from 'react-icons/fa';
import CustomModal from './CustomModal';
import styles from './SessionExpiredModal.module.css';

const SessionExpiredModal = ({
  isOpen,
  onContinue,
  onCancel,
  isLoading = false,
}) => {
  const handleContinue = () => {
    if (!isLoading) {
      onContinue();
    }
  };

  const handleCancel = () => {
    if (!isLoading) {
      onCancel();
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleCancel}
      title="Session Expired"
      size="sm"
      centered={true}
      closeOnOverlayClick={false}
      closeOnEscape={false}
      showCloseButton={false}
      showHeader={true}
      showFooter={true}
      animation="zoom"
      footer={
        <div className={styles.footerButtons}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={handleCancel}
            disabled={isLoading}
          >
            <FaTimesCircle />
            <span>Cancel</span>
          </button>
          <button
            type="button"
            className={styles.continueButton}
            onClick={handleContinue}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className={styles.spinner}></span>
                <span>Refreshing...</span>
              </>
            ) : (
              <>
                <FaSignInAlt />
                <span>Continue</span>
              </>
            )}
          </button>
        </div>
      }
    >
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <FaExclamationTriangle className={styles.warningIcon} />
        </div>
        <h3 className={styles.message}>Your session has expired</h3>
        <p className={styles.description}>
          Your login session has expired due to inactivity. 
          Click <strong>Continue</strong> to refresh your session and stay logged in, 
          or <strong>Cancel</strong> to return to the login page.
        </p>
      </div>
    </CustomModal>
  );
};

export default SessionExpiredModal;
